// 随机提示词生成器 - 提供多种类型的随机提示词

// 人物描述相关词汇
const CHARACTERS = [
  '年轻女孩', '年轻男孩', '老人', '小孩', '婴儿', 
  '青少年', '中年人', '孕妇', '双胞胎', '三胞胎',
  '亚洲人', '欧洲人', '非洲人', '拉丁美洲人', '中东人',
  '运动员', '舞者', '艺术家', '科学家', '医生', 
  '教师', '学生', '工程师', '农民', '渔民',
  '士兵', '警察', '消防员', '宇航员', '潜水员',
  '摄影师', '模特', '厨师', '服务员', '建筑师',
  '音乐家', '演员', '导演', '作家', '记者'
];

// 人物情绪相关词汇
const EMOTIONS = [
  '开心的', '悲伤的', '愤怒的', '惊讶的', '恐惧的',
  '平静的', '焦虑的', '困惑的', '兴奋的', '无聊的',
  '满足的', '失望的', '骄傲的', '羞愧的', '嫉妒的',
  '感激的', '绝望的', '希望的', '怀疑的', '信任的',
  '好奇的', '厌倦的', '放松的', '紧张的', '孤独的'
];

// 场景描述相关词汇
const SCENES = [
  '城市街道', '乡村田野', '海滩', '山脉', '森林',
  '沙漠', '雪地', '丛林', '草原', '湖泊',
  '河流', '瀑布', '峡谷', '岛屿', '洞穴',
  '花园', '公园', '操场', '校园', '医院',
  '办公室', '工厂', '农场', '牧场', '渔港',
  '机场', '火车站', '地铁', '商场', '市场',
  '餐厅', '咖啡馆', '酒吧', '图书馆', '博物馆',
  '剧院', '电影院', '体育场', '游乐园', '水族馆',
  '动物园', '温室', '实验室', '太空站', '潜水艇'
];

// 时间描述相关词汇
const TIMES = [
  '黎明', '日出', '早晨', '中午', '下午',
  '黄昏', '日落', '傍晚', '夜晚', '午夜',
  '春天', '夏天', '秋天', '冬天', '雨季',
  '旱季', '台风季', '飓风季', '雪季', '花季',
  '收获季', '节日', '假期', '工作日', '周末',
  '古代', '中世纪', '文艺复兴', '工业革命', '现代',
  '未来', '后启示录', '赛博朋克', '蒸汽朋克', '奇幻'
];

// 天气描述相关词汇
const WEATHER = [
  '晴朗', '多云', '阴天', '雾霾', '雨天',
  '暴雨', '雷雨', '冰雹', '下雪', '暴风雪',
  '龙卷风', '飓风', '台风', '沙尘暴', '热浪',
  '寒流', '干燥', '潮湿', '闷热', '凉爽',
  '温暖', '寒冷', '霜冻', '结冰', '融雪'
];

// 动作描述相关词汇
const ACTIONS = [
  '走路', '跑步', '跳跃', '游泳', '攀爬',
  '飞行', '潜水', '滑行', '舞蹈', '唱歌',
  '演奏', '绘画', '写作', '阅读', '思考',
  '观察', '聆听', '触摸', '品尝', '嗅闻',
  '工作', '学习', '休息', '睡觉', '吃饭',
  '喝水', '烹饪', '清洁', '建造', '修理',
  '种植', '收获', '狩猎', '钓鱼', '探索',
  '冒险', '战斗', '保护', '救援', '治疗',
  '庆祝', '哀悼', '祈祷', '冥想', '交谈'
];

// 风格描述相关词汇
const STYLES = [
  '写实主义', '超现实主义', '印象派', '表现主义', '立体主义',
  '抽象主义', '极简主义', '波普艺术', '未来主义', '达达主义',
  '浪漫主义', '古典主义', '巴洛克', '洛可可', '新古典主义',
  '哥特式', '文艺复兴', '东方传统', '日式浮世绘', '中国水墨',
  '印度曼荼罗', '非洲部落', '美洲原住民', '澳洲土著', '波利尼西亚',
  '蒸汽朋克', '赛博朋克', '后启示录', '复古', '怀旧',
  '卡通', '动漫', '像素艺术', '低多边形', '8位风格',
  '水彩', '油画', '素描', '炭笔', '铅笔',
  '彩色铅笔', '马克笔', '墨水', '拼贴', '混合媒介'
];

// 颜色描述相关词汇
const COLORS = [
  '红色', '橙色', '黄色', '绿色', '青色',
  '蓝色', '紫色', '粉色', '棕色', '灰色',
  '黑色', '白色', '金色', '银色', '铜色',
  '多彩的', '单色的', '彩虹色', '霓虹色', '柔和色',
  '明亮的', '暗淡的', '饱和的', '不饱和的', '对比强烈的'
];

// 光线描述相关词汇
const LIGHTING = [
  '自然光', '人工光', '阳光', '月光', '星光',
  '烛光', '火光', '闪电', '霓虹灯', 'LED灯',
  '聚光灯', '散射光', '柔光', '硬光', '逆光',
  '侧光', '顶光', '底光', '轮廓光', '填充光',
  '高调光', '低调光', '戏剧性光线', '梦幻光线', '科幻光线'
];

// 主题描述相关词汇
const THEMES = [
  '爱情', '友谊', '家庭', '成长', '冒险',
  '战争', '和平', '生命', '死亡', '重生',
  '自然', '科技', '历史', '未来', '幻想',
  '恐怖', '悬疑', '喜剧', '悲剧', '史诗',
  '神话', '传说', '童话', '寓言', '科幻',
  '环保', '社会', '政治', '经济', '文化',
  '宗教', '哲学', '心理', '医学', '教育',
  '艺术', '音乐', '文学', '电影', '游戏',
  '体育', '美食', '旅行', '时尚', '建筑'
];

// 动物描述相关词汇
const ANIMALS = [
  '猫', '狗', '马', '牛', '羊',
  '猪', '鸡', '鸭', '鹅', '兔子',
  '老鼠', '松鼠', '浣熊', '狐狸', '狼',
  '熊', '鹿', '长颈鹿', '大象', '犀牛',
  '河马', '斑马', '猴子', '大猩猩', '猩猩',
  '狮子', '老虎', '豹子', '猎豹', '美洲狮',
  '鳄鱼', '蜥蜴', '蛇', '乌龟', '青蛙',
  '鱼', '鲨鱼', '海豚', '鲸鱼', '章鱼',
  '鹰', '猫头鹰', '鹦鹉', '企鹅', '蝴蝶'
];

// 植物描述相关词汇
const PLANTS = [
  '树', '灌木', '草', '花', '藤蔓',
  '苔藓', '蕨类', '仙人掌', '多肉植物', '棕榈树',
  '松树', '橡树', '柳树', '桦树', '枫树',
  '樱花', '梅花', '荷花', '向日葵', '玫瑰',
  '郁金香', '百合', '兰花', '菊花', '牡丹',
  '薰衣草', '蒲公英', '小雏菊', '紫罗兰', '风信子',
  '小麦', '水稻', '玉米', '大豆', '向日葵',
  '棉花', '茶树', '咖啡树', '可可树', '橄榄树',
  '葡萄藤', '草莓', '苹果树', '桃树', '柑橘树'
];

// 食物描述相关词汇
const FOODS = [
  '面包', '蛋糕', '饼干', '巧克力', '冰淇淋',
  '水果', '蔬菜', '肉类', '海鲜', '奶制品',
  '米饭', '面条', '饺子', '披萨', '汉堡',
  '三明治', '沙拉', '汤', '炖菜', '烧烤',
  '煎炸', '蒸煮', '烘焙', '腌制', '熏制',
  '中餐', '西餐', '日料', '韩餐', '印度菜',
  '泰国菜', '意大利菜', '法国菜', '墨西哥菜', '地中海菜',
  '早餐', '午餐', '晚餐', '点心', '小吃',
  '饮料', '咖啡', '茶', '果汁', '酒'
];

// 建筑描述相关词汇
const BUILDINGS = [
  '房屋', '公寓', '别墅', '城堡', '宫殿',
  '神庙', '教堂', '清真寺', '寺庙', '佛塔',
  '摩天大楼', '办公楼', '工厂', '仓库', '车库',
  '学校', '医院', '图书馆', '博物馆', '美术馆',
  '剧院', '电影院', '体育场', '游泳池', '健身房',
  '商场', '超市', '市场', '餐厅', '酒店',
  '桥梁', '隧道', '水坝', '灯塔', '风车',
  '水车', '谷仓', '温室', '花园', '公园',
  '码头', '火车站', '机场', '太空站', '地下城'
];

// 交通工具描述相关词汇
const VEHICLES = [
  '汽车', '摩托车', '自行车', '三轮车', '卡车',
  '公交车', '出租车', '救护车', '消防车', '警车',
  '火车', '地铁', '电车', '缆车', '索道',
  '飞机', '直升机', '热气球', '飞艇', '火箭',
  '宇宙飞船', '卫星', '太空站', '探测器', '登陆舱',
  '船', '帆船', '游艇', '渔船', '货船',
  '邮轮', '潜水艇', '气垫船', '水翼船', '独木舟',
  '坦克', '装甲车', '吉普车', '雪地车', '沙漠车',
  '滑板', '滑轮', '滑雪板', '冲浪板', '风帆'
];

// 科技描述相关词汇
const TECHNOLOGY = [
  '电脑', '智能手机', '平板', '电视', '相机',
  '机器人', '人工智能', '虚拟现实', '增强现实', '混合现实',
  '3D打印', '无人机', '物联网', '大数据', '云计算',
  '区块链', '加密货币', '量子计算', '生物技术', '纳米技术',
  '基因工程', '克隆技术', '干细胞', '脑机接口', '神经网络',
  '太阳能', '风能', '水能', '核能', '地热能',
  '电动汽车', '自动驾驶', '超级高铁', '太空旅行', '火星殖民',
  '智能家居', '可穿戴设备', '增强人类', '生物机械', '全息投影',
  '量子通信', '深空探测', '深海探测', '极地探测', '时间旅行'
];

// 幻想元素描述相关词汇
const FANTASY = [
  '魔法', '巫师', '女巫', '法师', '德鲁伊',
  '骑士', '战士', '弓箭手', '刺客', '牧师',
  '龙', '凤凰', '独角兽', '狮鹫', '美人鱼',
  '精灵', '矮人', '兽人', '巨魔', '地精',
  '天使', '恶魔', '神灵', '泰坦', '巨人',
  '吸血鬼', '狼人', '木乃伊', '僵尸', '幽灵',
  '魔剑', '魔杖', '魔法书', '魔法药水', '魔法水晶',
  '魔法门', '魔法塔', '魔法森林', '魔法山脉', '魔法湖泊',
  '魔法城堡', '魔法学院', '魔法议会', '魔法战争', '魔法末日'
];

// 科幻元素描述相关词汇
const SCIFI = [
  '太空船', '星际战舰', '殖民地', '太空站', '月球基地',
  '火星基地', '外星人', '外星文明', '外星技术', '外星语言',
  '机器人', '人工智能', '仿生人', '克隆人', '基因改造人',
  '时间机器', '时间旅行', '平行宇宙', '多元宇宙', '虫洞',
  '黑洞', '白洞', '奇点', '反物质', '暗物质',
  '激光武器', '粒子武器', '等离子武器', '引力武器', '量子武器',
  '力场护盾', '隐形技术', '传送技术', '心灵感应', '念力控制',
  '赛博空间', '虚拟现实', '增强现实', '脑机接口', '意识上传',
  '后人类', '奇点科技', '纳米技术', '量子计算', '生物计算'
];

/**
 * 生成随机提示词
 * @param options 配置选项
 * @returns 随机生成的提示词
 */
export const generateRandomPrompt = (options: {
  includeCharacter?: boolean;
  includeEmotion?: boolean;
  includeScene?: boolean;
  includeTime?: boolean;
  includeWeather?: boolean;
  includeAction?: boolean;
  includeStyle?: boolean;
  includeColor?: boolean;
  includeLighting?: boolean;
  includeTheme?: boolean;
  includeAnimal?: boolean;
  includePlant?: boolean;
  includeFood?: boolean;
  includeBuilding?: boolean;
  includeVehicle?: boolean;
  includeTechnology?: boolean;
  includeFantasy?: boolean;
  includeScifi?: boolean;
  minElements?: number;
  maxElements?: number;
} = {}): string => {
  // 默认配置
  const defaultOptions = {
    includeCharacter: true,
    includeEmotion: true,
    includeScene: true,
    includeTime: false,
    includeWeather: false,
    includeAction: false,
    includeStyle: false,
    includeColor: false,
    includeLighting: false,
    includeTheme: false,
    includeAnimal: false,
    includePlant: false,
    includeFood: false,
    includeBuilding: false,
    includeVehicle: false,
    includeTechnology: false,
    includeFantasy: false,
    includeScifi: false,
    minElements: 3,
    maxElements: 5
  };

  // 合并选项
  const finalOptions = { ...defaultOptions, ...options };

  // 创建可用词汇类别数组
  const availableCategories: string[][] = [];
  
  if (finalOptions.includeCharacter) availableCategories.push(CHARACTERS);
  if (finalOptions.includeEmotion) availableCategories.push(EMOTIONS);
  if (finalOptions.includeScene) availableCategories.push(SCENES);
  if (finalOptions.includeTime) availableCategories.push(TIMES);
  if (finalOptions.includeWeather) availableCategories.push(WEATHER);
  if (finalOptions.includeAction) availableCategories.push(ACTIONS);
  if (finalOptions.includeStyle) availableCategories.push(STYLES);
  if (finalOptions.includeColor) availableCategories.push(COLORS);
  if (finalOptions.includeLighting) availableCategories.push(LIGHTING);
  if (finalOptions.includeTheme) availableCategories.push(THEMES);
  if (finalOptions.includeAnimal) availableCategories.push(ANIMALS);
  if (finalOptions.includePlant) availableCategories.push(PLANTS);
  if (finalOptions.includeFood) availableCategories.push(FOODS);
  if (finalOptions.includeBuilding) availableCategories.push(BUILDINGS);
  if (finalOptions.includeVehicle) availableCategories.push(VEHICLES);
  if (finalOptions.includeTechnology) availableCategories.push(TECHNOLOGY);
  if (finalOptions.includeFantasy) availableCategories.push(FANTASY);
  if (finalOptions.includeScifi) availableCategories.push(SCIFI);

  // 如果没有可用类别，返回默认提示词
  if (availableCategories.length === 0) {
    return '美丽的风景';
  }

  // 随机决定要使用的元素数量
  const numElements = Math.floor(
    Math.random() * (finalOptions.maxElements - finalOptions.minElements + 1) + finalOptions.minElements
  );

  // 随机选择类别和词汇
  const selectedWords: string[] = [];
  const usedCategories: Set<number> = new Set();

  // 确保至少使用一个类别
  if (numElements > 0 && availableCategories.length > 0) {
    const firstCategoryIndex = Math.floor(Math.random() * availableCategories.length);
    const firstCategory = availableCategories[firstCategoryIndex];
    const wordIndex = Math.floor(Math.random() * firstCategory.length);
    selectedWords.push(firstCategory[wordIndex]);
    usedCategories.add(firstCategoryIndex);
  }

  // 添加剩余的元素
  for (let i = 1; i < numElements; i++) {
    // 如果所有类别都已使用，则重置已使用类别集合
    if (usedCategories.size === availableCategories.length) {
      usedCategories.clear();
    }

    // 选择一个未使用的类别
    let categoryIndex;
    do {
      categoryIndex = Math.floor(Math.random() * availableCategories.length);
    } while (usedCategories.has(categoryIndex) && usedCategories.size < availableCategories.length);

    const category = availableCategories[categoryIndex];
    const wordIndex = Math.floor(Math.random() * category.length);
    selectedWords.push(category[wordIndex]);
    usedCategories.add(categoryIndex);
  }

  // 将选定的词汇组合成提示词
  return selectedWords.join('，');
};

/**
 * 根据特定主题生成随机提示词
 * @param theme 主题类型
 * @returns 随机生成的提示词
 */
export const generateThemeBasedPrompt = (theme: string): string => {
  switch (theme.toLowerCase()) {
    case '人物':
      return generateRandomPrompt({
        includeCharacter: true,
        includeEmotion: true,
        includeAction: true,
        includeStyle: true,
        includeColor: false,
        includeLighting: true,
        minElements: 3,
        maxElements: 5
      });
    
    case '风景':
      return generateRandomPrompt({
        includeCharacter: false,
        includeScene: true,
        includeTime: true,
        includeWeather: true,
        includeStyle: true,
        includeColor: true,
        includeLighting: true,
        minElements: 3,
        maxElements: 5
      });
    
    case '动物':
      return generateRandomPrompt({
        includeAnimal: true,
        includeAction: true,
        includeScene: true,
        includeStyle: true,
        minElements: 3,
        maxElements: 4
      });
    
    case '植物':
      return generateRandomPrompt({
        includePlant: true,
        includeScene: true,
        includeTime: true,
        includeWeather: false,
        includeStyle: true,
        includeColor: true,
        includeLighting: true,
        minElements: 3,
        maxElements: 5
      });
    
    case '食物':
      return generateRandomPrompt({
        includeFood: true,
        includeStyle: true,
        includeColor: true,
        includeLighting: true,
        minElements: 2,
        maxElements: 4
      });
    
    case '建筑':
      return generateRandomPrompt({
        includeBuilding: true,
        includeScene: true,
        includeTime: true,
        includeWeather: true,
        includeStyle: true,
        includeColor: false,
        includeLighting: true,
        minElements: 3,
        maxElements: 5
      });
    
    case '交通':
      return generateRandomPrompt({
        includeVehicle: true,
        includeScene: true,
        includeAction: true,
        includeStyle: true,
        minElements: 3,
        maxElements: 4
      });
    
    case '科技':
      return generateRandomPrompt({
        includeTechnology: true,
        includeScene: true,
        includeStyle: true,
        includeColor: true,
        includeLighting: true,
        minElements: 2,
        maxElements: 4
      });
    
    case '幻想':
      return generateRandomPrompt({
        includeFantasy: true,
        includeScene: true,
        includeAction: true,
        includeStyle: true,
        includeColor: true,
        includeLighting: true,
        minElements: 3,
        maxElements: 5
      });
    
    case '科幻':
      return generateRandomPrompt({
        includeScifi: true,
        includeScene: true,
        includeAction: true,
        includeStyle: true,
        includeColor: true,
        includeLighting: true,
        minElements: 3,
        maxElements: 5
      });
    
    default:
      // 默认生成综合类型的提示词
      return generateRandomPrompt();
  }
};

// 预设的随机提示词主题
export const PROMPT_THEMES = [
  '人物', '风景', '动物', '植物', '食物', 
  '建筑', '交通', '科技', '幻想', '科幻'
];

// 用户提供的预设提示词
export const PRESET_PROMPTS = [
  // 1. 小红龙
  '一只小小的红龙蜷缩在中世纪巫师的桌子上, 微距镜头(f/2.8, 50mm), 佳能EOS R5, 柔焦效果, 清晨柔和光线, 淡雅色彩, 奇幻蒸汽, 宁静氛围, 16K和8K分辨率, 精细细节, 中世纪魅力',
  
  // 2. 演讲者
  '一位有魅力的演讲者, 棕色短发微微凌乱, 圆脸, 刮过胡子, 黑色边框圆形眼镜, 右手持黑色麦克风, 激情演讲, 左手做手势, 表情生动, 浅蓝色套头衫, 白色T恤, 黑色挂绳, AI/MLAPI徽章, 专业会议场景',
  
  // 3. 山巅小屋
  '被洪水侵蚀的山巅小屋, 从低角度展示一座饱经风霜的木屋, 摇摇欲坠地矗立在陡峭的悬崖边缘, 小阳台晾晒衣物, 正午烈日下锐利阴影, 苍翠绿植环绕悬崖底部, 茂密植被遮掩广阔风景, 阴森孤立氛围, 锐利高对比度细节, 荒凉孤独感',
  
  // 4. 女孩自拍
  '一张20岁黑发女子的自拍照, 她身处一间凌乱的房间中, 墙上挂着一张写着"深度伪造"(DEEPFAKE)的海报, 光线柔和并有方向性, 写实风格, 高清细节',
  
  // 5. 士兵剧照
  '电影场景, 前线士兵的肩部特写近景, 眼神专注而迷人, 背景中可见爆炸, 有胶片颗粒和景深效果, 电影感画面, 战争场景, 情感表达, 高对比度',
  
  // 6. 咖啡店的女人
  '一张原始的写实照片, 一个女人在咖啡馆里用笔记本电脑打字, 她身边放着一杯咖啡, 聚焦在女人的脸上, 自然光线, 生活场景, 日常瞬间, 真实表达',
  
  // 7. 手持武器的女孩
  '电影场景, 一个年轻的金发女孩穿着脏脏的浅绿色连衣裙, 拿着一把巨大的现代猎枪, 背景是戏剧性的橙色火焰和爆炸, 强烈对比, 紧张氛围, 电影质感',
  
  // 8. 智能手机展示
  '一个智能手机产品展示, 智能手机显示沉浸式壁纸和时间, 模糊的绿松石背景, 产品摄影, 高清细节, 商业风格, 现代感, 科技美学',
  
  // 9. 埃菲尔铁塔开幕
  '1889年巴黎埃菲尔铁塔开幕时的照片, 高耸的铁结构仍在建设中, 背景是熙熙攘攘的巴黎天际线, 人群穿着19世纪晚期的服装聚集在周围, 惊叹于这座标志性的新地标, 历史性时刻, 建筑壮举, 复古色调, 宏大历史氛围',
  
  // 10. 电影海报
  '"失落之城的回声" - 电影海报, 一位坚韧的探险者, 穿着磨损的皮夹克, 手中拿着地图, 站在古老丛林的边缘, 人物脸部被部分阴影遮掩增添神秘感, 背景是被藤蔓覆盖的失落之城, 透过迷雾隐约可见, 废墟深处散发着微弱的金色光芒, 黑暗、富有情绪的光线, 写实且电影感十足, 柔和的土色调和质感, 暗示时间的流逝与衰败'
];

// 用户提供的预设提示词（英文版本）
export const PRESET_PROMPTS_EN = [
  // 1. 小红龙
  'A tiny red dragon sleeps curled up in a nest on a medieval wizard\'s table. Shot with a macro lens (f/2.8, 50mm) and a Canon EOSR5',
  
  // 2. 演讲者
  'A charismatic speaker is captured mid-speech, his short, tousled brown hairs lightly messy on top. He has a round face, clean-shaven, and wears rounded rectangular glasses with dark rims',
  
  // 3. 山巅小屋
  'Design a hyper-realistic scene of a weathered wooden house teetering on the edge of a rugged cliff, viewed from a low angle',
  
  // 4. 女孩自拍
  'snapchat portrait of a brunette 20-year old woman, in a messy room with a poster on the wall reading "DEEPFAKE", soft directional lighting',
  
  // 5. 士兵剧照
  'cinematic scene, over the shoulder close-up portrait of a soldier on the front line, intense and mesmerizing look, as explosions are seen in the background, film grain, depth of field',
  
  // 6. 咖啡店的女人
  'a raw realistic photo of a woman typing on her laptop in a cafe, cup of coffee by her side, focusing on woman\'s face',
  
  // 7. 手持武器的女孩
  'cinematic scene, A young blonde girl in a dirty light green dress, holding a big modern shotgun weapon against a backdrop of dramatic orange flames and explosions',
  
  // 8. 智能手机展示
  'a smartphone product showcase, smartphone display showing immersive wallpaper and time, blurred turquoise background',
  
  // 9. 埃菲尔铁塔开幕
  'A photograph from the opening of the Eiffel Tower in Paris in 1889, the towering iron structure, still under construction, against a backdrop of a bustling Parisian skyline',
  
  // 10. 电影海报
  'Movie poster: "Echoes of the Lost City" - A rugged explorer with a worn leather jacket, a map in hand, standing at the edge of an ancient jungle'
];

// 随机选择一个主题并生成提示词
export const getRandomPrompt = (): string => {
  // 有 20% 的概率使用预设提示词
  if (Math.random() < 0.2) {
    const randomIndex = Math.floor(Math.random() * PRESET_PROMPTS.length);
    // 优先使用英文提示词以获得更好的生成结果
    return PRESET_PROMPTS_EN[randomIndex];
  } else {
    const randomThemeIndex = Math.floor(Math.random() * PROMPT_THEMES.length);
    const randomTheme = PROMPT_THEMES[randomThemeIndex];
    return generateThemeBasedPrompt(randomTheme);
  }
};
